module.exports = __webpack_public_path__ + "static/media/cyber-corn-explosion-1.8b5e9b65.jpg";